import React from 'react';
import { pureRender } from 'epic-alt-utils';
import { Locale, Search, CtaButton, SignIn, SignedIn, SiteNav, SearchExtension, MobileMenuButtons } from '../';
import { NavActions } from '../../actions';
import autobind from 'core-decorators/lib/autobind';
import './rightnav.sass';
import './rightnav-mobile.sass';

@pureRender
export default class RightNav extends React.Component {

    constructor(props) {
        super(props);

        //the min width the active search input box can be set to
        this.minWidth = 250;

        this.rightNavWidth = 0;

        this.state = {
            searchMaxWidth: 0,
            maxWidth: 0,
            mobileCollapsed: false
        };
    }

    @autobind
    showMenu() {
        if (!this.props.isActive) {
            NavActions.mobileNavActive(true);
            NavActions.mobileNavActiveLinks(true);
        } else {
            NavActions.mobileNavActive(false);
            NavActions.mobileNavActiveLinks(false);
        }

        //Reset all other clickable items
        NavActions.egNavActive(false);
        NavActions.tabletNavActive(false);
        NavActions.mobileLocaleActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.searchActive(false);
        NavActions.mobileUserActive(false);
    }

    @autobind
    toggleIconBar(e) {
        if (e) e.preventDefault();

        this.setState({
            mobileCollapsed: !this.state.mobileCollapsed
        });
    }

    componentDidMount() {
        setTimeout(() => {
            //get the width of the cta component for calculating width in tablet mode
            const cta = document.getElementById('cta');
            this.rightNavWidth = 0;
            if (cta) {
                this.rightNavWidth = cta.offsetWidth || 220; //220 is max-width for cta anchor
            } else {
                this.rightNavWidth = 220;
            }

            //search, locale, and user are hardcoding to prevent over querying the dom for the static numbers
            this.rightNavWidth += 60; //search width
            this.rightNavWidth += 60; //locale width
            this.rightNavWidth += 60; //user width

            this.determineMaxWidth(this.props.maxWidth);
        }, 1500);
    }

    componentWillReceiveProps(nextProps) {
        if (this.context.isTablet && (this.state.maxWidth !== nextProps.maxWidth || this.state.searchMaxWidth < 0)) {
            this.determineMaxWidth(nextProps.maxWidth);
        }
    }

    determineMaxWidth(maxWidth) {
        let width = maxWidth || this.minWidth;

        if (width > this.minWidth) {
            width -= this.rightNavWidth;
        } else {
            width = this.minWidth;
        }

        this.setState({
            searchMaxWidth: width,
            maxWidth
        });
    }

    render() {
        const isMobile = this.context.isMobile || false;
        const accountLinks = this.props.accountLinks || {};
        const userCompontent = (
            this.props.isLoggedIn ?
                <SignedIn
                    displayName={this.props.displayName}
                    isActive={this.props.mobileUserActive}
                    signOutLink={accountLinks.signOutLink}
                    dropdownLinks={accountLinks.dropdownLinks}
                    hideCallToAction={this.props.hideCallToAction}/> :
                <SignIn
                    isActive={this.props.mobileUserActive}
                    signInLinks={accountLinks.signInLinks}
                    hideCallToAction={this.props.hideCallToAction}/>
        );

        const ctaComponent = <CtaButton cta={this.props.callToAction}/>;

        const localeComponent = (
            <Locale
                localeOptions={this.props.localeOptions}
                isActive={this.props.mobileLocaleActive}
                locale={this.props.locale}
                hideCallToAction={this.props.hideCallToAction}/>
        );

        const active = this.props.isActive;

        return (
            <div id="rightNav" className={`right-col ${active ? 'active' : ''} ${isMobile ? 'rightnav-bg-color' : 'bg-color'}`}>
                {isMobile ?
                    <div className={`menu-icon ${active ? 'rightnav-bg-color' : 'accent-bg-color'}`} onClick={this.showMenu}>
                        <span
                            className={`lines ${active ? 'text-color text-color-before-after' : 'accent-text-color-bg accent-text-before-after'}`}>
                        </span>
                    </div>
                : ''}

                {isMobile ?
                    <div>
                        <div className={`mobile-overlay ${active ? 'active' : ''}`} onClick={this.showMenu}></div>
                        <div className={`rightNav bg-color ${this.props.searchActive ? 'search-focus' : ''}`}>
                            <div
                                id="iconBar"
                                className={`icon-bar-wrapper ${this.props.hideCallToAction ? 'cta-hidden' : ''}`}>

                                <a href="" className={`icon-bar-toggle ${this.state.mobileCollapsed ? 't-up' : 't-down'}`} onClick={this.toggleIconBar}>
                                    <span className="toggle text-color-border-after"></span>
                                </a>

                                <div className={`icon-bar accent-bg-color-before ${this.state.mobileCollapsed ? 'shrink' : ''}`}>

                                    {!this.props.hideSearch ?
                                        <SearchExtension
                                            active={this.props.searchActive}
                                            onSearch={this.props.onSearch}
                                            searchMaxWidth={this.state.searchMaxWidth}/> : <div/>}

                                    <MobileMenuButtons
                                       localeOptions={this.props.localeOptions}
                                       isLocaleActive={this.props.mobileLocaleActive}
                                       locale={this.props.locale}
                                       isLoggedIn={this.props.isLoggedIn}
                                       mobileUserActive={this.props.mobileUserActive}
                                       hideLocale={this.props.hideLocale}
                                       hideSignIn={this.props.hideSignIn}
                                       signInLinks={accountLinks.signInLinks}
                                       displayName={this.props.displayName}/>

                                    {!this.props.hideLocale ? localeComponent : <div/>}

                                    {!this.props.hideSignIn ? userCompontent : <div/>}

                                    {!this.props.hideCallToAction ? ctaComponent : <div/>}
                                </div>
                            </div>
                            <div className="mobile-links accent-bg-color-before">
                                <SiteNav
                                    links={this.props.links}
                                    mobileActiveLinkIndex={this.props.mobileActiveLinkIndex}
                                    showLinks={this.props.showLinks}/>
                            </div>
                        </div>
                    </div>
                :
                    <div className="rightNav bg-color">
                        {!this.props.hideSearch ?
                            <Search
                                isActive={this.props.searchActive}
                                onSearch={this.props.onSearch}
                                searchMaxWidth={this.state.searchMaxWidth}/> : <div/>}

                        {!this.props.hideLocale ? localeComponent : <div/>}

                        {!this.props.hideSignIn ? userCompontent : <div/>}

                        {!this.props.hideCallToAction ? ctaComponent : <div/>}
                    </div>
                }
            </div>
        );
    }
}

RightNav.propTypes = {
    searchActive: React.PropTypes.bool,
    isLoggedIn: React.PropTypes.bool,
    hideLocale: React.PropTypes.bool,
    hideSearch: React.PropTypes.bool,
    hideSignIn: React.PropTypes.bool,
    hideCallToAction: React.PropTypes.bool,
    callToAction: React.PropTypes.object,
    links: React.PropTypes.array,
    localeOptions: React.PropTypes.array,
    mobileActiveLinkIndex: React.PropTypes.number,
    mobileLocaleActive: React.PropTypes.bool,
    mobileUserActive: React.PropTypes.bool,
    displayName: React.PropTypes.string,
    locale: React.PropTypes.string,
    isActive: React.PropTypes.bool,
    showLinks: React.PropTypes.bool,
    accountLinks: React.PropTypes.object,
    onSearch: React.PropTypes.func,
    maxWidth: React.PropTypes.number
};

RightNav.contextTypes = {
    messages: React.PropTypes.object,
    isMobile: React.PropTypes.bool,
    isTablet: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/rightNav/RightNav.js
 **/